import store from '@/store'
// store 和 router 之间存在循环依赖（store/modules/permission.js 引用 router，router 通过
// 本文件又引用回 store），谁先被加载，另一方在这个时间点上可能还没初始化完，
// store.state 这里可能是 undefined，加一层兜底避免直接报错
const online = store && store.state ? store.state.online : true;
const manageRouter = {
    path: '/admin',
    name: 'admin',
    hidden: true,
    redirect: '/admin/ground-station-config',
    component: () => import('@/views/admin'),
    children: [
        {
            path: 'ground-station-config',
            name: 'groundStationConfig',
            component: () => import('@/views/admin/ground-station-config'),
            meta: {
                breadcrumb: [{
                    name: '地面站设置',
                    language: 'groundStationSetting',
                }]
            },
        },

        {
            path: 'parameter-set',
            name: 'parameterSet',
            component: () => import('@/views/admin/parameter-set'),
            meta: {
                breadcrumb: [{
                    name: '参数设置',
                    language: 'parameterSet',
                }]
            },
        },
        {
            path: 'device',
            name: 'device',
            component: () => import('@/views/admin/device'),
            meta: {
                breadcrumb: [{
                    name: '设备管理',
                    language: 'deviceManagement',
                }]
            }
        },
        {
            path: 'device/uav',
            name: 'uavDetails',
            component: () => import('@/views/admin/device/uav'),
            meta: {
                breadcrumb: [{
                    name: '设备管理',
                    language: 'deviceManagement',
                }, {
                    name: '设备详情(无人机)',
                    language: 'details_uav',
                }]
            },
            children: []
        },
        {
            path: 'device/uav/life-statistics',
            name: 'lifeStatistics',
            component: () => import('@/views/admin/device/uav/life-statistics'),
            meta: {
                breadcrumb: [{
                    name: '设备管理',
                    language: 'deviceManagement',
                }, {
                    name: '设备详情(无人机)',
                    language: 'details_uav',
                }, {
                    name: '寿命统计',
                    language: 'lifeStatistics',
                }]
            },
        },
        {
            path: 'device/ptz',
            name: 'ptzDetails',
            component: () => import('@/views/admin/device/ptz'),
            meta: {
                breadcrumb: [{
                    name: '设备管理',
                    language: 'deviceManagement',
                }, {
                    name: '设备详情(云台)',
                    language: 'details_PTZ',
                }]
            },
        },
        {
            path: 'device/battery',
            name: 'batteryDetails',
            component: () => import('@/views/admin/device/battery'),
            meta: {
                breadcrumb: [{
                    name: '设备管理',
                    language: 'deviceManagement',
                }, {
                    name: '设备详情(智能电池)',
                    language: 'details_battery',
                }]
            },
        },
        {
            path: 'device/rtk/:id',
            name: 'rtkDetails',
            component: () => import('@/views/admin/device/rtk'),
            props: true,
            meta: {
                breadcrumb: [{
                    name: '设备管理',
                    language: 'deviceManagement',
                }, {
                    name: '设备详情(RTK)',
                    language: 'details_rtk'
                }]
            },
        },
        {
            path: 'device/simulator',
            name: 'simulatorDetails',
            component: () => import('@/views/admin/device/simulator'),
            meta: {
                breadcrumb: [{
                    name: '设备管理',
                    language: 'deviceManagement',
                }, {
                    name: '设备详情(模拟机)',
                    language: 'details_simulator'
                }]
            },
        },
        {
            path: 'device/weather-station/:id',
            name: 'weatherStation',
            props: true,
            component: () => import('@/views/admin/device/weather-station'),
            meta: {
                breadcrumb: [{
                    name: '设备管理',
                    language: 'deviceManagement',
                }, {
                    name: '设备详情(气象站)',
                    language: 'weatherStation'
                }]
            },
        },
        /* 维空BOX设备管理 */
        {
            path: 'device/weikong-box',
            name: 'WeikongBox',
            component: () => import('@/views/admin/weikong-box'),
            meta: {
                breadcrumb: [{
                    name: '维空BOX设备管理',
                    language: 'deviceManagement',
                }]
            }
        },


        {
            path: 'share',
            name: 'share',
            component: () => import('@/views/admin/share'),
            meta: {
                breadcrumb: [{
                    name: '共享管理',
                    language: 'sharingManagement'
                }]
            }
        },
        /* 历史记录 */
        {
            path: 'history/flight-record',
            name: 'flightRecord',
            component: () => import('@/views/admin/history/flight-record'),
            meta: {
                keepAlive: true,
                breadcrumb: [{
                    name: '历史记录',
                    language: 'historyPlayback',
                },
                {
                    name: '飞行记录',
                    language: 'flightRecords',
                }]
            },
        },

        {
            path: 'history/flight-record/flyplay/:id',
            name: 'flyplay',
            props: true,
            component: () => import('@/views/admin/history/flyplay'),
            meta: {
                breadcrumb: [{
                    name: '历史回放',
                    language: 'historyPlayback',
                }, {
                    name: '飞行记录',
                    language: 'flightRecords',
                    path: '/admin/history/flight-record'
                }, {
                    name: '飞行记录播放',
                    language: 'flightRecordPlayback',
                }]
            },
        },

        {
            path: 'history/video',
            name: 'video',
            component: () => import('@/views/admin/history/video'),
            meta: {
                breadcrumb: [{
                    name: '历史回放',
                    language: 'historyPlayback',
                }, {
                    name: '视频记录',
                    language: 'videoRecords',
                }]
            }
        },
        {
            path: 'history/photo',
            name: 'photo',
            component: () => import('@/views/admin/history/photo'),
            meta: {
                breadcrumb: [{
                    name: '历史回放',
                    language: 'historyPlayback',
                }, {
                    name: '照片记录',
                    language: 'photoRecords',
                }]
            },
        },
        {
            path: 'history/inspection-record',
            name: 'inspection-record',
            component: () => import('@/views/admin/history/inspection-record'),
            meta: {
                breadcrumb: [{
                    name: '历史回放',
                    language: 'historyPlayback',
                }, {
                    name: '检查记录',
                    language: 'inspectionRecord',
                }]
            },
        },
        {
            path: 'history/mobile-spectrum',
            name: 'mobile-spectrum',
            component: () => import('@/views/admin/history/mobile-spectrum'),
            meta: {
                breadcrumb: [{
                    name: '历史回放',
                    language: 'historyPlayback',
                }, {
                    name: '手机频谱记录',
                    language: 'mobileSpectrumRecord',
                }]
            },
        },
        {
            path: 'history/life-detection',
            name: 'life-detection',
            component: () => import('@/views/admin/history/life-detection'),
            meta: {
                breadcrumb: [{
                    name: '历史回放',
                    language: 'historyPlayback',
                }, {
                    name: '生命探测记录',
                    language: 'lifeDetectionRecord',
                }]
            },
        },
        {
            path: 'history/inspection-record/details/:id',
            name: 'inspection-record-details',
            component: () => import('@/views/admin/history/inspection-record/details'),
            meta: {
                breadcrumb: [{
                    name: '历史回放',
                    language: 'historyPlayback',
                }, {
                    name: '检查记录',
                    language: 'inspectionRecord',
                }, {
                    name: '检查记录详情',
                    language: 'flightRecordDetails',
                }]
            },
        },
        /* 操作日志 */
        {
            path: 'oplog/system',
            name: 'system',
            component: () => import('@/views/admin/oplog/system'),
            meta: {
                breadcrumb: [
                    {
                        name: '操作日志',
                        language: 'oplog',
                    },
                    {
                        name: '系统操作',
                        language: 'systemOperation',
                    }
                ]
            },
        },
        {
            path: 'oplog/flight',
            name: 'flight',
            component: () => import('@/views/admin/oplog/flight'),
            meta: {
                breadcrumb: [
                    {
                        name: '操作日志',
                        language: 'oplog',
                    },
                    {
                        name: '飞行操作',
                        language: 'flightOperation',
                    }
                ]
            },
        },
        {
            path: 'productAftersale',
            name: 'productAftersale',
            component: () => import('@/views/admin/productAftersale'),
            meta: {
                breadcrumb: [{
                    name: '产品售后',
                    language: 'productAftersale',
                }]
            },
        },
        {
            path: 'model-data-management',
            name: 'modelDataManagement',
            component: () => import('@/views/admin/model-data-management'),
            meta: {
                breadcrumb: [{
                    name: '三维数据融合平台',
                    language: 'modelDataManagement',
                }]
            },
        }
    ]
}


if (online) {
    manageRouter.children.push(
        {
            path: 'history/lpr',
            name: 'lpr',
            component: () => import('@/views/admin/history/lpr'),
            meta: {
                breadcrumb: [
                    {
                        name: '历史回放',
                        language: 'historyPlayback',
                    }, {
                        name: '识别记录',
                        language: 'lpr',
                    }
                ]
            },
        }
    )
    manageRouter.children.push(
        /* 企业用户信息 */
        {
            path: 'enterprise-user',
            name: 'enterpriseUser',
            component: () => import('@/views/admin/enterprise-user'),
            meta: {
                breadcrumb: [{
                    name: '企业用户信息',
                    language: 'enterpriseUsers',
                }]
            },
        }
    )
}

export default manageRouter
